(function () {
  "use strict";

  var form       = document.getElementById("kbisForm");
  var submitBtn  = document.getElementById("kbisSubmitBtn");
  var btnText    = document.getElementById("kbisBtnText");
  var btnLoader  = document.getElementById("kbisBtnLoader");
  var successMsg = document.getElementById("kbisSuccessMsg");
  var errorMsg   = document.getElementById("kbisErrorMsg");

  var SHEET_URL = 'https://script.google.com/macros/s/AKfycbyyM2NcczWLY9o4AyupcoBVHYNYhbJjiVeycrs_gT5eswlsJ1U1tf-kCemgIVfVtfZ9_w/exec';
  var selectedCountryCode = "+1"; // Default USA

  /* ── Country Dropdown ─────────────────────────── */
  var flagBox         = document.getElementById("kbisFlagBox");
  var countryDropdown = document.getElementById("kbisCountryDropdown");
  var selectedFlag    = document.getElementById("kbisSelectedFlag");

  flagBox.addEventListener("click", function (e) {
    e.stopPropagation();
    countryDropdown.classList.toggle("open");
    // Close multiselect if open
    document.getElementById("kbisMultiDropdown").classList.remove("open");
    document.getElementById("kbisMultiDisplay").classList.remove("active");
  });

  document.querySelectorAll(".kbis-country-option").forEach(function (opt) {
    opt.addEventListener("click", function () {
      selectedCountryCode  = this.getAttribute("data-code");
      selectedFlag.textContent = this.getAttribute("data-flag");
      countryDropdown.classList.remove("open");
    });
  });

  /* ── Multi Select ─────────────────────────────── */
  var multiDisplay  = document.getElementById("kbisMultiDisplay");
  var multiDropdown = document.getElementById("kbisMultiDropdown");
  var multiText     = document.getElementById("kbisMultiText");

  multiDisplay.addEventListener("click", function (e) {
    e.stopPropagation();
    multiDropdown.classList.toggle("open");
    multiDisplay.classList.toggle("active");
    // Close country dropdown if open
    countryDropdown.classList.remove("open");
  });

  multiDropdown.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
    cb.addEventListener("change", function () {
      var checked = Array.from(
        multiDropdown.querySelectorAll('input[type="checkbox"]:checked')
      ).map(function (c) { return c.value; });

      multiText.textContent = checked.length > 0
        ? checked.join(", ")
        : "Multiple Select Available";
    });
  });

  /* ── Close dropdowns on outside click ────────── */
  document.addEventListener("click", function () {
    countryDropdown.classList.remove("open");
    multiDropdown.classList.remove("open");
    multiDisplay.classList.remove("active");
  });

  /* ── UTM Params ───────────────────────────────── */
  function getUTM() {
    var p = new URLSearchParams(window.location.search);
    return {
      utm_source:   p.get('utm_source')   ? '- ' + p.get('utm_source')   : '- utm_source',
      utm_medium:   p.get('utm_medium')   ? '- ' + p.get('utm_medium')   : '- utm_medium',
      utm_campaign: p.get('utm_campaign') ? '- ' + p.get('utm_campaign') : '- utm_campaign',
      gclid:        p.get('gclid')        ? '- ' + p.get('gclid')        : '- gclid'
    };
  }

  /* ── Loading State ────────────────────────────── */
  function setLoading(on) {
    submitBtn.disabled      = on;
    btnText.style.display   = on ? "none"         : "inline";
    btnLoader.style.display = on ? "inline-block" : "none";
  }

  /* ── Clear Errors ─────────────────────────────── */
  function clearErrors() {
    errorMsg.style.display = "none";
    form.querySelectorAll(".kbis-error").forEach(function (el) {
      el.classList.remove("kbis-error");
    });
    document.querySelector(".kbis-phone-wrap").classList.remove("kbis-error");
  }

  /* ── Validation ───────────────────────────────── */
  function validate(d) {
    var ok = true;

    if (!d.Name) {
      document.getElementById("kbisName").classList.add("kbis-error");
      ok = false;
    }
    if (!d.Email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(d.Email)) {
      document.getElementById("kbisEmail").classList.add("kbis-error");
      ok = false;
    }
    if (!d.Mobile || !/^\d{7,15}$/.test(d.Mobile)) {
      document.querySelector(".kbis-phone-wrap").classList.add("kbis-error");
      ok = false;
    }
    if (!d.Priority) {
      document.getElementById("kbisPriority").classList.add("kbis-error");
      ok = false;
    }

    return ok;
  }

  /* ── Form Submit ──────────────────────────────── */
  form.addEventListener("submit", function (e) {
    e.preventDefault();
    clearErrors();
    successMsg.style.display = "none";

    // Get selected products
    var selectedProducts = Array.from(
      multiDropdown.querySelectorAll('input[type="checkbox"]:checked')
    ).map(function (c) { return c.value; }).join(", ");

    var data = {
      Company:  document.getElementById("kbisCompany").value.trim(),
      Name:     document.getElementById("kbisName").value.trim(),
      City:     document.getElementById("kbisCity").value.trim(),
      Mobile:   document.getElementById("kbisMobile").value.trim(),
      Email:    document.getElementById("kbisEmail").value.trim(),
      Industry: document.getElementById("kbisIndustry").value,
      Priority: document.getElementById("kbisPriority").value,
      Message:  document.getElementById("kbisRemarks").value.trim(),
      Product:  selectedProducts || "Not Selected"
    };

    if (!validate(data)) {
      errorMsg.textContent   = "❌ Please fill in all required fields correctly.";
      errorMsg.style.display = "block";
      return;
    }

    var utm = getUTM();

    setLoading(true);

    // ── Send to Google Sheet ──────────────
    fetch(SHEET_URL, {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        formName : 'KBISRegistration',
        company  : data.Company,
        name     : data.Name,
        city     : data.City,
        mobile   : selectedCountryCode + data.Mobile,
        email    : data.Email,
        industry : data.Industry,
        product  : data.Product,
        priority : data.Priority,
        remarks  : data.Message,
        utm_source   : utm.utm_source,
        utm_medium   : utm.utm_medium,
        utm_campaign : utm.utm_campaign,
        gclid        : utm.gclid
      })
    })
      .then(function () {
        setLoading(false);
        form.reset();
        multiText.textContent    = "Multiple Select Available";
        selectedFlag.textContent = "🇺🇸";
        selectedCountryCode      = "+1";
        form.querySelectorAll(".kbis-row").forEach(function (r) {
          r.style.display = "none";
        });
        successMsg.style.display = "block";
      })
      .catch(function (err) {
        console.error("Submit Error:", err);
        setLoading(false);
        errorMsg.textContent   = "❌ Something went wrong. Please try again.";
        errorMsg.style.display = "block";
      });

});

})();